module.exports = __webpack_public_path__ + "img/39.69786c61.jpg";